/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { GlobalPermMap } from './GlobalPermMap';
const TenantPermissionsParser = /* #__PURE__ */ parsers.object([
    ['hasPerms', /* #__PURE__ */ parsers.exactly(true), 'has_perms'],
    ['perms', GlobalPermMap],
]);
export class TenantPermissions extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TenantPermissionsParser.decode(input).map(res => new TenantPermissions(res));
    }
    static unsafeDecode(input) {
        return TenantPermissions.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TenantPermissionsParser.encode(data);
    }
    static schema() {
        return TenantPermissionsParser.schema();
    }
}
